import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Command, CommandBase, FilteredCommand, MultiselectCommand } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { MessageService } from '../../../core/service/message.service';
import { invoiceCommand } from '../../command/unpaid-invoice';
import { InvoiceService } from '../data/invoice.service';
import { Observable } from 'rxjs';
import { Invoice } from '../../model/invoice';

@Injectable()
export class AttestCommandHandler implements ICommandHandler {
  constructor(
    private _service: InvoiceService,
    private _messageService: MessageService
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command.id != invoiceCommand.attest) {
      return false;
    }
    if (command instanceof Command && command.context instanceof Invoice) {
      if (command.context.attestedDate && command.context.attestedDate.hasValue()) {
        this._messageService.showMessage('INVOICE.INFORMATION_TEXT.INVOICE_ALREADY_CERTIFIED');
        return false;
      }
      return command.id === invoiceCommand.attest;
    }
    if (command instanceof MultiselectCommand) {
      return command.items.length > 0;
    }
    if (command instanceof FilteredCommand) {
      return command.filterProvider && command.totalAffectedItemsControlValue > 0;
    }
    return false;
  }

  execute(command: CommandBase): Observable<boolean> {
    if (command instanceof Command) {
      return this._service.attest(command.context.id).pipe(
        map(item => {
          if (command.context instanceof Invoice) {
            Object.assign(command.context, item);
          }
          return true;
        })
      );
    }

    if (command instanceof MultiselectCommand) {
      return this._service.attestMany(command.items.map(item => item.id)).pipe(
        map(data => {
          command.items.forEach(item => {
            item.selected = false;
            Object.assign(
              item,
              data.find(x => x.id === item.id)
            );
          });
          return true;
        })
      );
    }

    if (command instanceof FilteredCommand) {
      return this._service
        .attestByFilter({
          filter: command.filterProvider.filterState,
          includedIds: command.includedIds,
          excludedIds: command.excludedIds,
          affectedItemsCount: command.totalAffectedItemsControlValue,
        })
        .pipe(
          map(res => {
            return true;
          })
        );
    }
  }
}
